<span [class]="'badge ' + color">{{value}}</span>
